export const createLabels = {

	createLabelForMultipleAutocomplete () {
		var autocompleteContent = document.querySelectorAll(
			".v-autocomplete__content .v-list input"
		);
		if (autocompleteContent.length) {
			var listItems = document.querySelectorAll(".v-autocomplete__content a.v-list__tile");
			for (var i = 0; i < listItems.length; i++) {
				var itemTitle = listItems[i].querySelector(".v-list__tile__title");
				var itemInput = listItems[i].querySelector("input");
				var label = document.createElement("label");
				var idInput = "input__" + Math.floor(Math.random() * (1000 - 1 + 1)) + 1;
				itemTitle.parentNode.insertBefore(label, itemTitle);
				label.appendChild(itemTitle);

				itemInput.setAttribute("id", idInput);
				label.setAttribute("for", idInput);
			}
		}
	},

	addAriaLabelForInputWithRole (role) {
		let inputs = document.querySelectorAll("input");
		for (let i = 0; i < inputs.length; i++) {
			let input = inputs[i];
			if (role === input.getAttribute("role")) {
				input.setAttribute('aria-label', 'label for input');
			}
		}
	}
};
